import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"arrow-left\"><path d=\"M390 477c10 9 10 22 0 29-9 9-22 9-28 0L122 272c-10-10-10-22 0-29L365 6c9-9 22-9 29 0 9 10 9 23 0 29L173 256z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-left.svg
// module id = 177
// module chunks = 0